var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rb-product-tile__status-message",
      class: { "--black": _vm.type === _vm.StatusMessageTypeE.SOLDOUT },
    },
    [
      _vm.isMemberAccess
        ? _c("span", {
            staticClass:
              "rb-plp-product-tile__icon rb-plp-product-tile__icon--top-left common__icon common__icon--locker-red",
            class: {
              "common__icon--locker-red--closed": !_vm.userLoggedIn,
              "common__icon--locker-red--open": _vm.userLoggedIn,
            },
            attrs: { title: false },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "rb-product-tile__message" },
        [
          _vm.formattedRemainingTime
            ? [
                _vm._v(
                  "\n      " + _vm._s(_vm.formattedRemainingTime) + "\n    "
                ),
              ]
            : [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }